const CheckCircleFilledIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="inherit"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12Zm8.077 4.851 8.222-8.84-1.098-1.022-7.124 7.66-2.278-2.45-1.098 1.022 3.376 3.63Z"
        fillRule="evenodd"
      />
    </svg>

  );
};

export default CheckCircleFilledIcon;
